// extracted by mini-css-extract-plugin
export var breadcrumb = "breadcrumb-module--breadcrumb--tKw+T";
export var breadcrumb_link = "breadcrumb-module--breadcrumb_link--V2O2i";